<template>
  <div class="animated fadeIn">
    <b-card v-show="(showForm==false)">
      <div slot="header">Leave Entitlement  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="8" >
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Employee/Crew</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.crewname" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Leave Name</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.LeaveNM" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuLeaveShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>                  
                </b-col>
              </b-row>                      
        </b-col>
        <b-col lg="4">
              <b-row>
                <b-col class="pr-1" cols="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Outstanding/Active</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="YesNoAll"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col class="pl-1" cols="6">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
        show-empty
      >
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(LeaveTotal)="data">
          {{data.item.LeaveTotal | numFormat}}
        </template>
        <template v-slot:cell(TakenTtl)="data">
          {{data.item.TakenTtl | numFormat}}
        </template>
        <template v-slot:cell(LeaveBlc)="data">
          {{data.item.LeaveBlc | numFormat}}
        </template>      
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col lg="10" xl="6">
        <b-card >
            <div slot="header">Leave Entitlement - Form </div>
                    <b-input-group >
                      <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.crewinfo" readonly :state="!$v.frmdata.crewkey.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.projectname" ></b-form-input>
                    </b-input-group>
                  <b-input-group>
                        <b-input-group-prepend><label>Leave Name</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.LeaveNM" readonly :state="!$v.frmdata.LeaveID.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuLeaveShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                        <b-input-group-prepend><label>Working Period</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.Periode" :state="!$v.frmdata.Periode.$error"></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Claim Period</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.StartDate" type="date" :state="!$v.frmdata.StartDate.$error" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.FinishDate" type="date" :state="!$v.frmdata.FinishDate.$error"></b-form-input>
                  </b-input-group>
                  <b-row>
                    <b-col cols="7">
                      <b-input-group>
                          <b-input-group-prepend><label>Total Leave Enttl. </label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.LeaveTotal" type="number" ></b-form-input>
                          <b-input-group-prepend><span class="input-group-text" style="width:70px;">Days</span> </b-input-group-prepend>
                          <b-form-checkbox  class="ml-1 mt-2" v-model="frmdata.Tahunan" value=1 unchecked-value=0>Annual/Yearly Period</b-form-checkbox>
                      </b-input-group>
                    </b-col>
                    <b-col cols="5">
                      <b-input-group>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Expired</span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.expireDate" type="date" ></b-form-input>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
      <b-modal v-model="lkuLeaveShow" size="lg" :hide-footer="true" title="List of Employee Leave" :centered="true" :lazy="true">
          <lku-leave @click="onSelectLkuLeave" ></lku-leave>
      </b-modal>        

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import myNumber from "../../components/my-number";
import leaveenttl from "../../apis/leaveenttl";
import dropdown from "../../data/dropdown";
import lkuCrew from "../lookup/lkuCrew";
import lkuLeave from '../lookup/lkuLeave';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading, myNumber, lkuCrew, lkuLeave},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      crewkey: { required },
      LeaveID: { required },
      LeaveTotal: { required },
      StartDate: { required },
      FinishDate: { required },
      expireDate: { required },
      LeaveBlc: { required },
      TakenTtl: { required },
      Periode: { required },
      Tahunan: { required },
      uraian: { required },    },
  }, 

  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      showForm:false,
      lkuLeaveShow:false,
      lkuCrewShow:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      terpilih:{LeaveEnttlID:''},
      YesNoAll: dropdown.YesNoAll,
      YesNo: dropdown.YesNo,
      frmdata:{LeaveID:'',crewkey:'',LeaveTotal:12,StartDate:'',FinishDate:'',Tahunan:1},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand: '1',
        fields:[
          {
            key: "crewinfo",
            label: "Employee",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
          {
            key: "locationname",
            label: "Location",
            sortable: true
          },
          {
            key: "uraian",
            label: "Leave Name",
            sortable: true
          },
          {
            key: "Periode",
            label: "Working Period",
            sortable: true
          },
          {
            key: "Berlaku",
            label: "Claim Period",
            sortable: true
          },
          {
            key: "LeaveTotal",
            label: "Total Plafon",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "TakenTtl",
            label: "Claimed",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "LeaveBlc",
            label: "Balance",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ]        
      },
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onSelectLkuCrew: async function (_selected) {
        this.frmdata.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.frmdata[key] = _selected[key];
            }        
        this.tblData.crewkey=_selected.crewkey;
        this.tblData.crewname=_selected.crewname;
        this.tblData.crewnik=_selected.crewnik;
        this.lkuCrewShow=false;
    },    
    onSelectLkuLeave: function(_selected){
        this.frmdata.LeaveID =_selected.LeaveID;
        this.frmdata.LeaveNM =_selected.LeaveNM;
        this.frmdata.uraian =_selected.LeaveNM;
        this.frmdata.Tahunan =_selected.Tahunan;
        this.tblData.LeaveID =_selected.LeaveID;
        this.tblData.LeaveNM =_selected.LeaveNM;
        this.lkuLeaveShow=false;
    },    
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await leaveenttl.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewname = '';
        this.tblData.crewnik =  '';
        this.tblData.crewkey='';
        this.tblData.LeaveID ='';
        this.tblData.LeaveNM ='';

        this.tblData.outstand =  '';
        this.refresh();
    },
    add: function() {
        const keysNumber = ['LeaveTotal'];
        for (var key in this.frmdata) {
            if (keysNumber.indexOf(key) >= 0 ) {
              this.frmdata[key] = 0;
            } else {
              this.frmdata[key] = '';
            } 
        }
      this.frmdata.LeaveEnttlID='';
      this.showForm=true;
    },
    edit: function() {
      if (this.terpilih.LeaveEnttlID) {
        const keysNumber = ['LeaveTotal'];
        for (var key in this.frmdata) {
            if (keysNumber.indexOf(key) >= 0 ) {
              this.frmdata[key] = 0;
            } else {
              this.frmdata[key] = '';
            } 
        }
        for (var key in this.terpilih) {
            this.frmdata[key] = this.terpilih[key];
        }
        this.frmdata.StartDate = moment(this.terpilih.StartDate).format('YYYY-MM-DD');
        this.frmdata.FinishDate = moment(this.terpilih.FinishDate).format('YYYY-MM-DD');
        this.frmdata.expireDate = (this.terpilih.expireDate) ? moment(this.terpilih.expireDate).format('YYYY-MM-DD'):'';
        this.showForm=true;
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.terpilih.LeaveEnttlID) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await leaveenttl.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }        
          }
    },
    rowClicked(record, index) {
      if (this.terpilih.LeaveEnttlID==record.LeaveEnttlID) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await leaveenttl.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    save: async function () {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            this.isLoading=true;
            try {
              const data={};
              for (var key in this.frmdata) {
                  data[key] = this.frmdata[key];
              }              
              data.StartDate = moment(this.frmdata.StartDate).format('YYYY-MM-DD');
              data.FinishDate = moment(this.frmdata.FinishDate).format('YYYY-MM-DD');
              data.expireDate = (this.frmdata.expireDate) ? moment(this.frmdata.expireDate).format('YYYY-MM-DD') : '';
              await leaveenttl.save(data);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
            this.isLoading=false;
        }
    },    
    closeFrm(){
      this.showForm=false;
    },    
    close(){
      router.push("/payroll/home");
    },    

  }
};
</script>
